var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 581,
    height: 880,
    viewBox: "0 0 581 880",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3654_54766)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    transform: "matrix(0.770867 0.636996 -0.637951 0.770077 510.596 84.4814)",
    fill: "url(#paint0_linear_3654_54766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.669 75.7754L542.569 110.902L545.442 172.449L574.542 137.323L571.669 75.7754ZM542.569 110.902L481.496 119.608L452.396 154.735L513.469 146.029L542.569 110.902ZM455.27 216.282L426.17 251.409L429.043 312.956L458.143 277.829L455.27 216.282Z",
    fill: "url(#paint1_linear_3654_54766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.469 146.028L516.342 207.575L487.243 242.702L484.369 181.155L513.469 146.028ZM484.369 181.155L423.297 189.861L394.197 224.988L455.27 216.282L484.369 181.155Z",
    fill: "#EBF5FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3654_54766)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    transform: "matrix(0.770892 0.636965 -0.637976 0.770056 574.142 137.803)",
    fill: "url(#paint2_linear_3654_54766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.217 129.096L606.116 164.222L608.989 225.767L638.09 190.641L635.217 129.096ZM606.116 164.222L545.041 172.929L515.94 208.054L577.015 199.348L606.116 164.222ZM518.813 269.599L489.712 304.725L492.585 366.27L521.686 331.144L518.813 269.599Z",
    fill: "url(#paint3_linear_3654_54766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.015 199.347L579.888 260.892L550.787 296.018L547.914 234.473L577.015 199.347ZM547.914 234.473L486.839 243.18L457.738 278.305L518.813 269.599L547.914 234.473Z",
    fill: "#EBF5FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3654_54766)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    transform: "matrix(0.770892 0.636965 -0.637976 0.770056 637.687 191.124)",
    fill: "url(#paint4_linear_3654_54766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.762 182.417L669.661 217.543L672.535 279.088L701.635 243.962L698.762 182.417ZM669.661 217.543L608.586 226.249L579.485 261.375L640.56 252.669L669.661 217.543ZM582.359 322.92L553.258 358.046L556.131 419.591L585.232 384.465L582.359 322.92Z",
    fill: "url(#paint5_linear_3654_54766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.56 252.668L643.433 314.213L614.332 349.339L611.459 287.794L640.56 252.668ZM611.459 287.794L550.384 296.5L521.283 331.626L582.358 322.92L611.459 287.794Z",
    fill: "#EBF5FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3654_54766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.387 215.547L425.287 250.674L428.16 312.221L457.26 277.094L454.387 215.547ZM425.287 250.674L364.214 259.38L335.114 294.506L396.187 285.8L425.287 250.674ZM337.988 356.053L308.888 391.18L311.761 452.727L340.861 417.601L337.988 356.053Z",
    fill: "#99CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.187 285.8L399.06 347.347L369.961 382.474L367.087 320.926L396.187 285.8ZM367.087 320.926L306.015 329.633L276.915 364.759L337.988 356.053L367.087 320.926Z",
    fill: "#EBF5FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_3654_54766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.935 268.867L488.834 303.993L491.707 365.538L520.808 330.412L517.935 268.867ZM488.834 303.993L427.759 312.7L398.658 347.825L459.733 339.119L488.834 303.993ZM401.531 409.37L372.43 444.496L375.303 506.041L404.404 470.915L401.531 409.37Z",
    fill: "#99CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.733 339.118L462.606 400.663L433.505 435.789L430.632 374.244L459.733 339.118ZM430.632 374.244L369.557 382.951L340.456 418.076L401.531 409.37L430.632 374.244Z",
    fill: "#EBF5FF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_3654_54766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.48 322.188L552.379 357.314L555.253 418.859L584.354 383.733L581.48 322.188ZM552.379 357.314L491.304 366.02L462.204 401.146L523.279 392.44L552.379 357.314ZM465.077 462.691L435.976 497.817L438.849 559.362L467.95 524.236L465.077 462.691Z",
    fill: "#99CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.278 392.439L526.151 453.984L497.05 489.11L494.177 427.565L523.278 392.439ZM494.177 427.565L433.102 436.271L404.001 471.397L465.076 462.691L494.177 427.565Z",
    fill: "#EBF5FF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_3654_54766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.104 355.318L308.005 390.445L310.878 451.992L339.978 416.866L337.104 355.318ZM308.005 390.445L246.932 399.151L217.832 434.278L278.905 425.572L308.005 390.445ZM220.705 495.825L191.605 530.952L194.479 592.499L223.578 557.372L220.705 495.825Z",
    fill: "#99CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.905 425.571L281.778 487.118L252.678 522.245L249.805 460.698L278.905 425.571ZM249.805 460.698L188.732 469.404L159.632 504.531L220.705 495.825L249.805 460.698Z",
    fill: "#EBF5FF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_3654_54766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.652 408.639L371.551 443.765L374.424 505.31L403.525 470.184L400.652 408.639ZM371.551 443.765L310.476 452.472L281.375 487.597L342.45 478.891L371.551 443.765ZM284.248 549.142L255.148 584.268L258.021 645.813L287.122 610.687L284.248 549.142Z",
    fill: "#99CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.45 478.89L345.323 540.435L316.222 575.561L313.349 514.016L342.45 478.89ZM313.349 514.016L252.274 522.723L223.173 557.848L284.248 549.142L313.349 514.016Z",
    fill: "#EBF5FF"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_3654_54766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.198 461.96L435.097 497.086L437.97 558.631L467.071 523.505L464.198 461.96ZM435.097 497.086L374.022 505.792L344.921 540.918L405.996 532.212L435.097 497.086ZM347.794 602.463L318.693 637.589L321.567 699.133L350.668 664.008L347.794 602.463Z",
    fill: "#99CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.996 532.211L408.869 593.756L379.768 628.882L376.895 567.337L405.996 532.211ZM376.895 567.337L315.82 576.043L286.719 611.169L347.794 602.463L376.895 567.337Z",
    fill: "#EBF5FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 300.049L221.109 309.416L250.648 350.851L189.539 341.484L160 300.049Z",
    fill: "#EBF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M399 792.167L460.109 801.535L489.648 842.97L428.539 833.602L399 792.167Z",
    fill: "#EBF5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M569.074 700.495L526.006 753.016L480.468 756.181L523.537 703.66L569.074 700.495Z",
    fill: "#EBF5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.838 185.315L297.419 212.677L278.918 282.734L318.337 255.372L336.838 185.315Z",
    fill: "#99CAFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3654_54766",
    x1: 41.9341,
    y1: -11.2451,
    x2: 41.4349,
    y2: 45.2594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3654_54766",
    x1: 571.669,
    y1: 75.7754,
    x2: 397.332,
    y2: 286.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#99CAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#99CAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3654_54766",
    x1: 41.9341,
    y1: -11.2451,
    x2: 41.4349,
    y2: 45.2594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3654_54766",
    x1: 635.217,
    y1: 129.096,
    x2: 460.888,
    y2: 340.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#99CAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#99CAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3654_54766",
    x1: 41.9341,
    y1: -11.2451,
    x2: 41.4349,
    y2: 45.2594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3654_54766",
    x1: 698.762,
    y1: 182.417,
    x2: 524.434,
    y2: 393.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#99CAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#99CAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3654_54766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.770867 0.636996 -0.637951 0.770077 510.596 84.4814)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3654_54766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.770892 0.636965 -0.637976 0.770056 574.142 137.803)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3654_54766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.770892 0.636965 -0.637976 0.770056 637.687 191.124)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3654_54766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.770867 0.636996 -0.637951 0.770077 393.314 224.253)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3654_54766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.770892 0.636965 -0.637976 0.770056 456.86 277.574)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_3654_54766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.770892 0.636965 -0.637976 0.770056 520.405 330.895)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_3654_54766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.770867 0.636996 -0.637951 0.770077 276.031 364.024)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_3654_54766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.770892 0.636965 -0.637976 0.770056 339.577 417.346)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_3654_54766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.770892 0.636965 -0.637976 0.770056 403.123 470.667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternRight);
export default __webpack_public_path__ + "static/media/pattern-right.cde11b52dd40ff648a03ef3d5980f7e1.svg";
export { ForwardRef as ReactComponent };